import { createAction, props } from '@ngrx/store';
import { CompanyParticipantsIds } from './models/company-participants.model';
import { OutputFormat } from './models/output-format.enum';

export const createProfileReport = createAction(
  scoped`Create Profile Report`,
  props<{
    profiles: { prId?: number; crmId?: number; name?: string }[];
    profileType: 'contact' | 'fund' | 'institution';
    useCustomSettings?: boolean;
    includedContacts?: CompanyParticipantsIds[];
    combinedSecurityIds?: number[];
    reportedQuarters?: string[];
    outputFormat?: OutputFormat;
  }>()
);

export const createProfileReportStarted = createAction(scoped`Create Profile Report Started`);
export const createProfileReportFinished = createAction(scoped`Create Profile Report Finished`);

export const openProfileReportDrawer = createAction(
  scoped`Open Profile Report Drawer`,
  props<{
    profiles: { prId?: number | null; crmId?: number | null; name?: string | null }[];
    profileType: 'contact' | 'fund' | 'institution';
    combinedSecurityIds?: number[];
    reportedQuarters?: string[];
    moduleName?: string;
  }>()
);
export const openParticipantProfileReportDrawer = createAction(
  scoped`Open Participant Profile Report Drawer`,
  props<{
    profiles: { prId?: number | null; crmId?: number | null; name?: string | null }[];
    profileType: 'contact' | 'fund' | 'institution';
    includedContacts?: CompanyParticipantsIds[];
    moduleName?: string;
  }>()
);

export const createItineraryReport = createAction(
  scoped`Create Itinerary Report`,
  props<{
    eventId: string;
    eventName: string;
    isConfigurableDisabled: boolean;
  }>()
);

export const openItineraryReportDrawer = createAction(
  scoped`Open Itinerary Report Drawer`,
  props<{
    eventId: string;
    eventName: string;
    startDate?: string | null;
    endDate?: string | null;
    eventType?: string;
    configurableDisableReason?: 'activityLimit' | 'externalParticipantLimit';
    activities?: {
      activityId: string;
      subject?: string;
      date: string;
      timeZone: string;
      participants: { ipreoCompanyId: number }[];
    }[];
  }>()
);

export const createItineraryReportFinished = createAction(
  scoped`Create Itinerary Report Finished`,
  props<{
    eventId: string;
  }>()
);

function scoped(templateString: TemplateStringsArray) {
  return '[Common Reporting] ' + templateString[0];
}
